let lockCount = 0;
export function lockClick(lock) {
    if (lock) {
        if (!lockCount) {
            document.body.classList.add('van-toast--unclickable');
        }
        lockCount++;
    }
    else {
        lockCount--;
        if (!lockCount) {
            document.body.classList.remove('van-toast--unclickable');
        }
    }
}
